import { useParams, Navigate } from "react-router-dom";

/**
 * Redirects legacy /outings/:outingId to /events/:outingId/edit
 * using the actual route param value (not the literal ":outingId" string).
 */
export function OutingRedirect() {
  const { outingId } = useParams<{ outingId: string }>();
  return <Navigate to={`../events/${outingId}/edit`} replace />;
}
